/**
 * @generated SignedSource<<b1a8cec756449ad36596a12a8dea21b3>>
 * @relayHash b2083552fb09e4a12fc0ea615b7c38aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9ed08e4739f86ec0fcccc58988e84d17da2e07221738213e6ea391516a78ea0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentOverviewInternalsQuery$variables = {
  helpCenterAri: string;
  isVersioningEnabled: boolean;
};
export type AgentOverviewInternalsQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentCard_AtlassianCsmAgentOverview">;
    } | null | undefined;
    readonly agents?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"multiVersionAgentSummary_AtlassianCsmAgentOverview">;
    }> | null | undefined;
    readonly id?: string;
  } | null | undefined;
};
export type AgentOverviewInternalsQuery = {
  response: AgentOverviewInternalsQuery$data;
  variables: AgentOverviewInternalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isVersioningEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentCard_AtlassianCsmAgentOverview"
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "multiVersionAgentSummary_AtlassianCsmAgentOverview"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentOverviewInternalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              {
                "condition": "isVersioningEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "agents",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCsmAiMultiVersionAgentResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "agentId"
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 2
                              }
                            ],
                            "concreteType": "CsmAiAgentVersionConnection",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CsmAiAgentVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionNumber"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "versionType"
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "agentIdentityConfig",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v4/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "type": "CsmAiAgentIdentity"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "message"
                                          }
                                        ],
                                        "type": "QueryError"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "versions(first:2)"
                          }
                        ],
                        "type": "CsmAiMultiVersionAgent"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f9ed08e4739f86ec0fcccc58988e84d17da2e07221738213e6ea391516a78ea0",
    "metadata": {},
    "name": "AgentOverviewInternalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9e2819b9e65c2c101c05a1d0e3b81ffb";

export default node;
